<template>
  <div id="browser">
    <v-container>
      <file-browser :axiosConfig="{ baseURL: '/' }" :user="$store.state.user" />
    </v-container>
  </div>
</template>

<script>
import FileBrowser from "../components/browser/src/FileBrowser"

export default {
  name: "Browser",
  data() {
    return {
      storage: {
        selected: "wd1"
      }
    }
  },
  components: {
    FileBrowser
  }
}
</script>

<style scoped></style>
